import { Form } from 'react-bootstrap';
import { BASE_LANGUAGE, LANGUAGE_LABELS } from '../../../utils/constants/marketLanguages';

// Kompaktný prepínač jazyka umiestnený PRIAMO VEDĽA textového poľa (nie nad ním) - v jednej línii,
// aby nemenil výšku riadku (dôležité najmä v tabuľke komponentov, kde by inak rozhodil zarovnanie
// ostatných buniek). Keď jednotka nemá vybraný žiadny cudzí trh, nezobrazuje sa vôbec.
const LanguageSwitch = ({ languages, active, onChange, size }) => {
    if (!languages || languages.length === 0) return null;

    return (
        <Form.Select
            size={size}
            value={active}
            onChange={e => onChange(e.target.value)}
            title={LANGUAGE_LABELS[active] ?? active}
            style={{
                width: 62,
                flex: '0 0 auto',
                fontSize: 12,
                fontWeight: 700,
                textAlign: 'center',
                paddingRight: 22,
            }}
        >
            <option value={BASE_LANGUAGE}>SK</option>
            {languages.map(lang => (
                <option key={lang} value={lang}>{lang.toUpperCase()}</option>
            ))}
        </Form.Select>
    );
};

export default LanguageSwitch;
